// Role-aware top navigation (D4).
// admin  = everything. executive = read-only (no Upload, no Users).
import HomeIcon from '@mui/icons-material/Home';
import DashboardIcon from '@mui/icons-material/Dashboard';
import InsightsIcon from '@mui/icons-material/Insights';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import PeopleIcon from '@mui/icons-material/People';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import CloudSyncIcon from '@mui/icons-material/CloudSync';

export const navItems = [
  { to: '/', label: 'Home', icon: HomeIcon, roles: ['admin', 'executive'], end: true },
  { to: '/dashboard', label: 'Dashboard', icon: DashboardIcon, roles: ['admin', 'executive'] },
  // { to: '/sundargarh-dashboard', label: 'Sundargarh Dashboard', icon: LocationCityIcon, roles: ['admin', 'executive'] },
  { to: '/normal-dashboard', label: 'Keonjhar Dashboard', icon: DashboardIcon, roles: ['admin', 'executive'] },
  { to: '/analytics', label: 'Analytics', icon: InsightsIcon, roles: ['admin', 'executive'] },
  // { to: '/sundargarh-analytics', label: 'Sundargarh Analytics', icon: InsightsIcon, roles: ['admin', 'executive'] },
  { to: '/normal-analytics', label: 'Keonjhar Analytics', icon: InsightsIcon, roles: ['admin', 'executive'] },
  { to: '/gps-accuracy', label: 'GPS Accuracy', icon: GpsFixedIcon, roles: ['admin', 'executive'] },
  { to: '/live-api-data', label: 'Live API Data', icon: CloudSyncIcon, roles: ['admin', 'executive'] },
  { to: '/upload', label: 'Upload', icon: CloudUploadIcon, roles: ['admin'] },
  { to: '/users', label: 'Users', icon: PeopleIcon, roles: ['admin'] },
];

// Sundargarh-only nav, shown instead of the full nav for district-scoped users.
export const sundargarhNavItems = [
  { to: '/sundargarh-hub', label: 'Home', icon: HomeIcon, roles: ['admin', 'executive'], end: true },
  { to: '/sundargarh-dashboard', label: 'Sundargarh Dashboard', icon: LocationCityIcon, roles: ['admin', 'executive'] },
  { to: '/sundargarh-analytics', label: 'Sundargarh Analytics', icon: InsightsIcon, roles: ['admin', 'executive'] },
];

export const navItemsForUser = (user) => {
  const items = user.district === 'sundargarh' ? sundargarhNavItems : navItems;
  return items.filter((item) => item.roles.includes(user.role));
};

export const navItemsForRole = (role) => navItems.filter((item) => item.roles.includes(role));

export default navItems;
